import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Input } from '../Input';
import { Button } from '../Button';
import { Icon } from '../Icon';
import CustomLink from '../CustomLink';
import { PRIVACY_POLICY_LINK } from '../../shared/links';
import { useSendResults } from '../../shared/use-send-results';
import styles from './EmailSlide.css';

function EmailSlide({
    setEmail,
    onContinue,
    title = 'Where should we write to her?',
    description = 'Enter her email to create her account and send her an invitation.',
    placeholder = 'Enter her personal email'
}) {
    const emailRef = useRef(null);
    const afterSuccessfulSendResults = callback => {
        document.getElementById('root').scrollIntoView({ block: 'start', behavior: 'smooth' });

        callback(); /* eslint-disable-line */
        onContinue();
    };

    const { fields, changeField, isPending, submitForm, errors } = useSendResults(setEmail, afterSuccessfulSendResults);
    const isDidYouMean = Boolean(errors.form?.didYouMean);

    useEffect(() => {
        setTimeout(() => {
            emailRef.current?.focus();
        }, 50);
    }, []);

    return (
        <form
            className={styles.root}
            onSubmit={submitForm}
        >
            <div className={styles.head}>
                <h1 className={styles.title}>
                    {title}
                </h1>
                <p className={styles.description}>{description}</p>
            </div>
            <Input
                value={fields.email}
                name='email'
                onChange={changeField}
                className={styles.input}
                placeholder={placeholder}
                errorText={errors.email || (!isDidYouMean && errors.form?.message)}
                disabled={isPending}
                inputProps={{ autoComplete: 'email', type: 'email', inputMode: 'email' }}
                emailDomainSuggestions={{
                    list: ['gmail.com', 'yahoo.com', 'icloud.com', 'hotmail.com', 'aol.com', 'outlook.com', 'comcast.net', 'att.net', 'live.com', 'mail.com', 'msn.com']
                }}
                inputRef={emailRef}
                didYouMean={errors.form?.didYouMean}
            />
            <div className={styles.agreementBlock}>
                <Icon name='lockSolid' />
                <span>
                    {'We respect your privacy and are committed to protecting your personal data. Your data will be processed in accordance with our '}
                    <CustomLink
                        to={PRIVACY_POLICY_LINK}
                        target='_blank'
                    >
                        Privacy&nbsp;Policy
                    </CustomLink>
                    .
                </span>
            </div>
            <div className={styles.footer}>
                <div className={styles.footerWrapper}>
                    <Button
                        type='accent'
                        label='Continue'
                        isLoading={isPending}
                        inSlide
                        buttonProps={{ type: 'submit' }}
                    />
                </div>
            </div>
        </form>
    );
}

EmailSlide.propTypes = {
    setEmail: PropTypes.func.isRequired,
    onContinue: PropTypes.func.isRequired,
    title: PropTypes.node,
    description: PropTypes.node,
    placeholder: PropTypes.string
};

export {
    EmailSlide
};
